import React from 'react';
import { ApplicationStageStat } from '~/src/types';
import { stageIcons } from '€lib/dashboard/constants';
import { Box, createStyles, makeStyles, Theme, Typography, useTheme } from '@material-ui/core';

const useCardStyles = makeStyles((theme: Theme) =>
    createStyles({
        description: {
            [theme.breakpoints.down('xs')]: {
                fontSize: '1rem',
                lineHeight: '140%',
                letterSpacing: '0.005em',
            },
            [theme.breakpoints.up('sm')]: {
                fontSize: '1.125rem',
            },
        },
    }),
);
interface DashboardApplicationCardProps {
    stat: ApplicationStageStat;
}

const DashboardApplicationCard: React.FC<DashboardApplicationCardProps> = ({ stat }) => {
    const theme = useTheme();
    const classes = useCardStyles();
    const StageIcon = stageIcons[stat.applicationStage];

    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            width="100%"
            minHeight={{ xs: '9.5rem', md: '11.375rem', lg: '9.5rem' }}
            border="2px solid #E7ECF2"
            borderRadius="1rem"
            p={2}
            my={1}
            mx={{ xs: 1, sm: 2 }}
        >
            <Box display="flex" justifyContent="space-between" width="100%">
                <Box paddingBottom={0.75} borderBottom={`2px solid ${theme.palette.primary.main}`}>
                    <Typography
                        variant="body1"
                        color="textPrimary"
                        style={{ fontSize: '32px', lineHeight: '100%' }}
                    >
                        {stat.total}
                    </Typography>
                </Box>
                <Box>
                    <StageIcon style={{ color: theme.palette.secondary.main }} />
                </Box>
            </Box>
            <Box display="flex" py={1} width="100%">
                <Typography className={classes.description} variant="body1" color="textSecondary">
                    {stat.label}
                </Typography>
            </Box>
        </Box>
    );
};

export default DashboardApplicationCard;
